import { useCallback, useState } from 'react';

import { useTimeout } from './useTimeout';

const useTimer = (timerMs: number, onComplete?: () => void): boolean => {
  const [isComplete, setIsComplete] = useState(false);

  const handleComplete = useCallback(() => {
    setIsComplete(true);
    onComplete?.();
  }, [onComplete]);

  useTimeout(handleComplete, timerMs);

  return isComplete;
};

export { useTimer };
